module.exports = __webpack_public_path__ + "static/media/tenassists.c0638103.jpg";